module.exports = __webpack_public_path__ + "static/media/InTheMix.bf03e1a4.jpg";